/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { RefreshAodRunRunActionsMutationResponse, RefreshAodRunRunActionsPathParams, RefreshAodRunRunActions400, RefreshAodRunRunActions404 } from "../models/RefreshAodRunRunActions";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { refreshAodRunRunActions } from "../axios/refreshAodRunRunActions";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const refreshAodRunRunActionsMutationKey = () => ["audit-reports-api", { url: '/aod-runs/:id/refresh' }] as const

export type RefreshAodRunRunActionsMutationKey = ReturnType<typeof refreshAodRunRunActionsMutationKey>

export function refreshAodRunRunActionsMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = refreshAodRunRunActionsMutationKey()
        return mutationOptions<RefreshAodRunRunActionsMutationResponse, ResponseErrorConfig<RefreshAodRunRunActions400 | RefreshAodRunRunActions404>, {id: RefreshAodRunRunActionsPathParams["id"]}, TContext>({
          mutationKey,
          mutationFn: async({ id }) => {
            return refreshAodRunRunActions(id, config)
          },
        })

}

/**
 * @description Re-executes the AOD run job for runs with COMPLETED_WITHOUT_EXPORT status
 * @summary Refresh a run
 * {@link /aod-runs/:id/refresh}
 */
export function useRefreshAodRunRunActions<TContext>(options: 
{
  mutation?: UseMutationOptions<RefreshAodRunRunActionsMutationResponse, ResponseErrorConfig<RefreshAodRunRunActions400 | RefreshAodRunRunActions404>, {id: RefreshAodRunRunActionsPathParams["id"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? refreshAodRunRunActionsMutationKey()

          const baseOptions = refreshAodRunRunActionsMutationOptions(config) as UseMutationOptions<RefreshAodRunRunActionsMutationResponse, ResponseErrorConfig<RefreshAodRunRunActions400 | RefreshAodRunRunActions404>, {id: RefreshAodRunRunActionsPathParams["id"]}, TContext>
          

          return useMutation<RefreshAodRunRunActionsMutationResponse, ResponseErrorConfig<RefreshAodRunRunActions400 | RefreshAodRunRunActions404>, {id: RefreshAodRunRunActionsPathParams["id"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<RefreshAodRunRunActionsMutationResponse, ResponseErrorConfig<RefreshAodRunRunActions400 | RefreshAodRunRunActions404>, {id: RefreshAodRunRunActionsPathParams["id"]}, TContext>
      
}